import styled from 'styled-components';

const EditCommentsContainer = styled.div``;

export { EditCommentsContainer };
